import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import Dance from "../views/Dance.vue";
//import GotoTest from "../views/GotoTest.vue";
//import Learning from "../views/Learning.vue";
import Youtube from "../views/Youtube.vue";
import Firestore from "../views/Firestore.vue";
import Shopping from "../views/Shopping.vue";
import Golang from "../views/Golang.vue";
import Flutter from "../views/Flutter.vue";
import Iot from "../views/Iot.vue";
import Music from "../views/Music.vue";
import Movie from "../views/Movie.vue";
import Photo from "../views/Photo.vue";
import SmartHome from "../views/SmartHome.vue";
import Study from "../views/Study.vue";
//import StudyFirebase from "../views/StudyFirebase.vue";
import StudySmartHome from "../views/StudySmartHome.vue";
import StudyLocalHome from "../views/StudyLocalHome.vue";
import StudyFirebaseOverview from "../views/StudyFirebaseOverview.vue";
import StudyFirestoreOverview from "../views/StudyFirestoreOverview.vue";
import StudySmartHomeOverview from "../views/StudySmartHomeOverview.vue";
import StudyLocalHomeOverview from "../views/StudyLocalHomeOverview.vue";
import StudyJavascriptAsyncAwait from "../views/StudyJavascriptAsyncAwait.vue";
import StudyLocalFulfillment from "../views/StudyLocalFulfillment.vue";
import Product from "../views/Product.vue";
import Manual from "../views/Manual.vue";
import EnglishGrammar from "../views/EnglishGrammar.vue";
import History from "../views/History.vue";
import OpenCV from "../views/OpenCV.vue";
import Reinforcement from "../views/Reinforcement.vue";
import Memo from "../views/Memo.vue";
import About from "../views/About.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Dance",
    component: Dance
  },
  {
    path: '/signin',
    name: 'Signin',
    component: Signin
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup
  },
  {
    path: "/home",
    name: "home",
    component: Home
  },
  {
    path: "/music",
    name: "Music",
    component: Music
  },
  {
    path: "/movie",
    name: "Movie",
    component: Movie
  },
  {
    path: "/youtube",
    name: "Youtube",
    component: Youtube
  },
  /*
  {
    path: "/learning",
    name: "Learning",
    component: Learning
  },
  */
  {
    path: "/firestore",
    name: "Firestore",
    component: Firestore
  },
  {
    path: "/shopping",
    name: "Shopping",
    component: Shopping
  },
  {
    path: "/golang",
    name: "Golang",
    component: Golang
  },
  {
    path: "/flutter",
    name: "Flutter",
    component: Flutter
  },
  {
    path: "/iot",
    name: "Iot",
    component: Iot
  },
  {
    path: "/photo",
    name: "Photo",
    component: Photo
  },
  {
    path: "/smart_home",
    name: "SmartHome",
    component: SmartHome
  },
  {
    path: "/study",
    name: "Study",
    component: Study
  },
  {
    path: "/study/firestore_overview",
    name: "StudyFirestoreOverview",
    component: StudyFirestoreOverview
  },
  {
    path: "/study/firebase_overview",
    name: "StudyFirebaseOverview",
    component: StudyFirebaseOverview
  },
  {
    path: "/study/smart_home_overview",
    name: "StudySmartHomeOverview",
    component: StudySmartHomeOverview
  },
  {
    path: "/study/local_home_overview",
    name: "StudyLocalHomeOverview",
    component: StudyLocalHomeOverview
  },
  {
    path: "/study/smart_home",
    name: "StudySmartHome",
    component: StudySmartHome
  },
  {
    path: "/study/local_home",
    name: "StudyLocalHome",
    component: StudyLocalHome
  },
  {
    path: "/study/javascript_async_await",
    name: "StudyJavascriptAsyncAwait",
    component: StudyJavascriptAsyncAwait
  },
  {
    path: "/study/local_fulfillment",
    name: "StudyLocalFulfillment",
    component: StudyLocalFulfillment
  },
  {
    path: "/product",
    name: "Product",
    component: Product
  },
  {
    path: "/manual",
    name: "Manual",
    component: Manual
  },
  {
    path: "/english_grammar",
    name: "EnglishGrammar",
    component: EnglishGrammar
  },
  {
    path: "/history",
    name: "History",
    component: History
  },
  {
    path: "/opencv",
    name: "OpenCV",
    component: OpenCV
  },
  {
    path: "/reinforcement",
    name: "Reinforcement",
    component: Reinforcement
  },
  {
    path: "/memo",
    name: "Memo",
    component: Memo
  },
  {
    path: "/about",
    name: "About",
    component: About
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
